<template>
  <div>
    <div class="columns is-multiline">
      <!-- 옵션 템플릿 목록 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="옵션 템플릿 목록" :useTab="false">
            <ul>
              <li v-for="(item, idx) in tableItems">
                <div class="lp-option-item">
                  <div>{{ item.name }}</div>
                  <div style="flex:1"></div>
                  <button class="button half" @click="selOption(item)" style="margin-right:4px" v-if="item.id>0">수정</button>
                  <button class="button half is-danger" @click="delOption(tableItems, idx)">삭제</button>
                  <i class="material-icons" v-if="!item.selected"
                     style="margin-left: 6px"
                     @click="item.selected?item.selected=false:item.selected=true">keyboard_arrow_down</i>
                  <i class="material-icons" v-if="item.selected"
                     style="margin-left: 6px"
                     @click="item.selected?item.selected=false:item.selected=true">keyboard_arrow_up</i>
                </div>
                <div style="padding:0.75rem">
                  <div class="columns" v-if="item.selected"
                    v-for="option in item.options" :key="option.name">
                    <div class="column">
                      <admin-form-item label="옵션값">
                        <input class="input"
                               :value="option.name"
                               :disabled="true"
                               type="text" maxlength="20">
                      </admin-form-item>
                    </div>
                    <div class="column">
                      <admin-form-item label="옵션가격">
                        <div class="flex">
                          <input class="input"
                                 :value="option.price"
                                 :disabled="true"
                                 type="number" maxlength="20">
                          <div class="flex space-between align-center">
                            <div style="margin-left:3px">원</div>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="btn-add-option" @click="addOption">옵션 추가하기</div>
          </admin-box-item>
        </div>
      </div>

      <!-- 옵션 추가/수정 -->
      <div class="column is-6" v-if="visible_option">
        <div class="box">
          <admin-box-item title="옵션 추가/수정" :useTab="false">
            <div v-if="section===1">
              <admin-form-item label="옵션 템플릿 선택">
                <span class="select">
                    <select @change="selectOptionTemplate">
                        <option value="" disabled selected>옵션 템플릿 선택</option>
                        <option v-for="option in optionTemplateArr"
                                :value="option.value">{{ option.label }}</option>
                      </select>
                </span>
              </admin-form-item>
            </div>
            <div v-if="section===2">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="옵션 선택">
                    <div>{{ product_selector.name }}</div>
                  </admin-form-item>
                </div>
                <div class="column is-7">
                  <admin-form-item label="옵션명">
                    <input class="input"
                           :value="product_selector.name"
                           @input="e => product_selector.name = e.target.value"
                           type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-12">
                  <admin-form-item label="카테고리" :isHeaderBlock="true" desc="* 카테고리를 설정하지 않는 경우, 모든 상품에서 이 옵션 템플릿을 사용할 수 있습니다.">
                    <div class="flex-align wrap">
                      <lp-adm-drop-input ref="adminput_prod"
                                         :data.sync="catArr1"
                                         @onSelect="res=>clickCategory(res.value, 'cat1')"
                                         placeholder="1차 카테고리"
                                         width="160px"
                                         listAlign="center"
                                         style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>

                      <lp-adm-drop-input ref="adminput_prod"
                                         :data.sync="cat2"
                                         @onSelect="res=>clickCategory(res.value, 'cat2')"
                                         placeholder="2차 카테고리"
                                         width="160px"
                                         listAlign="center"
                                         style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>

                      <lp-adm-drop-input ref="adminput_prod"
                                         :data.sync="cat3"
                                         @onSelect="res=>clickCategory(res.value, 'cat1')"
                                         placeholder="3차 카테고리"
                                         width="160px"
                                         listAlign="center"
                                         style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>
                      <button class="button is-primary" style="margin-bottom:4px" @click="addCategory">+추가</button>
                    </div>

                    <!-- 추가된 카테고리 -->
                    <div v-for="(cat, cat_idx) in product_selector.categorys" :key="`cat-${cat_idx}`">
                      <div class="flex-align" style="padding: 8px 0">
                        <div class="cat-name">{{ categoryName(cat) }}</div>
                        <i class="material-icons cat-close unselect" @click="deleteCategory(cat_idx)">close</i>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="옵션 종류">
                    <lp-radio @onSelect="setOptionType"
                              value_name="value"
                              label_name="label"
                              :val.sync="product_selector.option_type"
                              :data="optionType"
                              :block="true"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품옵션 기본값 여부">
                    <lp-check-bool :checked-val.sync="product_selector.required"
                                   label="상품 등록 시 기본 옵션으로 설정되게 합니다."></lp-check-bool>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <div class="columns" v-for="(option, idx) in product_selector.options" v-if="product_selector.options.length>0">
                    <div class="column">
                      <admin-form-item label="옵션값">
                        <input class="input"
                               :value="option.name"
                               @input="e => option.name = e.target.value"
                               type="text" maxlength="20">
                      </admin-form-item>
                    </div>
                    <div class="column">
                      <admin-form-item label="옵션가격">
                        <div class="flex">
                          <input class="input"
                                 :value="option.price"
                                 @input="e => option.price = e.target.value"
                                 type="number" maxlength="20">
                          <div class="flex space-between align-center">
                            <div style="margin-left:3px">원</div>
                            <i class="material-icons"
                               @click="deleteOptionValue(idx)"
                               style="line-height: 32px;margin-left:12px">close</i>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <button class="button is-grey" @click="addOptionValue">옵션값 추가</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="btn-group-justify-end">
          <button class="button" @click="cancel">취소</button>
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import LpRadio from "../../module/common/LpRadio";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    name: 'BasicProductOption',
    components: {
      LpAdmDropInput,
      LpCheckBool,
      LpRadio
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      },
      'selectedCategory.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'selectedCategory.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      },
    },
    data () {
      return {
        // 오른쪽 컬럼
        visible_option: false,
        // 1: 템플릿 선택 영역, 2: 옵션 추가, 선택 영역
        section:1,
        tableItems: [],
        selectedCategory: {
          category1_id: '',
          category2_id: '',
          category3_id: '',
        },
        catArr1: [],
        catArr2: [],
        catArr3: [],
        cat2: [],
        cat3: [],
        product_selector: {
          categorys: [],
          id: 0,
          name: '',
          type: 0,
          options: [{
            name: '',
            price: ''
          }],
        },
        optionTemplateArr: [],
        optionType: [
          { label: '필수 선택 옵션', value:0, detail:'*상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다.'},
          { label: '추가 옵션', value:1, detail:'*상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다.'}
        ]
      }
    },
    created() {
      this.getData();
      this.getCats();
    },
    methods: {
      // 옵션 종류 선택
      setOptionType(res){
        this.product_selector.option_type = res.value;
      },
      deleteOptionValue(index){
        removeIndex(this.product_selector.options, index);
      },
      addOptionValue(){
        this.product_selector.options.push({name: '옵션', price: 0})
      },
      // 옵션 추가하기
      addOption(){
        this.visible_option = true;
      },
      // 템플릿 수정
      selOption(item){
        this.visible_option = true;
        this.section=2;
        if (!item.categorys) {
          item.categorys = [];
        }
        this.product_selector = this.cloneItem(item);
      },
      // 템플릿 삭제
      delOption(items, index){
        if (items[index].id) {
          let value = {
            id: items[index].id,
            url: 'product/selector/',
            title: '옵션 템플릿을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      // 옵션 템플릿 선택
      selectOptionTemplate(e){
        if(e.target.value==0) {
          this.product_selector = {
            categorys: [],
            id: 0,
            name: '옵션명',
            option_type:0,
            type: 0,
            required:false,
            options: [
              {name: '옵션', price: 0},
              {name: '옵션', price: 0}
            ]
          }
        }
        else {
          for(let i=0; i<this.optionTemplateArr.length; i++) {
            if(this.optionTemplateArr[i].id==e.target.value){
              this.product_selector = this.optionTemplateArr[i];
              break;
            }
          }
        }
        this.section = 2;
      },
      cancel(){
        this.visible_option = false;
        this.section=1;
      },
      saveData(){
        if(this.product_selector.id===0) {
          this.$axios.post(this.getUrl('product/selector'), this.product_selector).then(res => {
            if (res.status === 200) {
              this.visible_option = false;
              this.toast('저장되었습니다.');
              this.visible_option = false;
              this.section = 1;

              this.getData();
            }
          })
        }
        else {
          this.$axios.patch(this.getUrl('product/selector/'+this.product_selector.id), this.product_selector).then(res => {
            if (res.status === 200) {
              this.visible_option = false;
              this.toast('저장되었습니다.');
              this.visible_option = false;
              this.section = 1;

              this.getData();
            }
          })
        }
      },
      getData(){
        this.$axios.get(this.getUrl('product/selector')).then(res=>{
          this.tableItems = res.data;

          this.optionTemplateArr = [{ label: '새 옵션 추가', value: 0 }];
          this.optionTemplateArr = this.optionTemplateArr.concat(res.data);
        })
      },
      clickCategory (value, type) {
        if (type === 'cat1') {
          this.selectedCategory.category1_id = value;
          this.selectedCategory.category2_id = '';
          this.selectedCategory.category3_id = '';
        } else if (type === 'cat2') {
          this.selectedCategory.category2_id = value;
          this.selectedCategory.category3_id = '';
        } else if (type === 'cat3') {
          this.selectedCategory.category3_id = value;
        }
      },
      addCategory() {
        if(this.selectedCategory.category1_id) {
          let data = {
            category1_id: this.selectedCategory.category1_id,
            category2_id: this.selectedCategory.category2_id,
            category3_id: this.selectedCategory.category3_id,
          }
          this.product_selector.categorys.push(data);
        }
        else {
          this.toast('카테고리를 선택하고 추가하세요.');
        }
      },
      deleteCategory (cat_idx) {
        let cat = this.product_selector.categorys[cat_idx];
        if(cat.id) {
        //  삭제 api 호출
          let url = `product/selector/${this.product_selector.id}/selector_category/${cat.id}`;
          this.$axios.delete(this.getUrl(url)).then(res => {
            if(res.status===200) {
              removeIndex(this.product_selector.categorys, cat_idx);
            }
          })
        }
        else {
          removeIndex(this.product_selector.categorys, cat_idx);
        }
      },
      categoryName(cat) {
        let name = '';
        if(cat.category1_id) {
          name += find(this.catArr1, 'value', cat.category1_id).label;
        }
        if(cat.category2_id) {
          name += ' > ' + find(this.catArr2, 'value', cat.category2_id).label;
        }
        if(cat.category3_id) {
          name += ' > ' + find(this.catArr3, 'value', cat.category3_id).label;
        }
        return name;
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat(this.catArr2, this.selectedCategory.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.selectedCategory.category2_id);
          });
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-option-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px
  .lp-option-item div
    margin auto 0
    margin-right 8px
  .lp-option-item div:last-child
    margin-right 0

  .btn-add-option
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  .cat-name
    color $primary

  .cat-close
    color white
    background-color $primary
    border-radius 50%
    font-size 14px
    margin-left 5px
</style>
